export const rooms = [
    {
        id: "room_001",
        roomType: "Single Bed",
        description: "Perfect for solo travelers, this cozy room offers a comfortable single bed, modern furnishings, and essential amenities such as free Wi-Fi, a work desk, and a private bathroom. Ideal for business trips or short stays, it provides a peaceful retreat at an affordable price.",
        features: [
            "Single Bed",
            "Air Conditioning",
            "Wi-Fi",
            "Flat-screen TV",
            "Work Desk"
        ],
        amenities: [
            "Free Breakfast",
            "Daily Housekeeping",
            "24/7 Room Service",
            "Laundry Service"
        ],
        pricing: {
            perNight: 4000,
            currency: "INR",
            discounts: {
                weekly: 10,
                monthly: 20
            }
        },
        images: "https://images.unsplash.com/photo-1560184897-502a475f7a0d?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",



        occupancy: {
            maxAdults: 1,
            maxChildren: 0
        },
        roomSize: "200 sqft",
        foodAvailability: {
            roomService: true,
            contactNumber: "+91 8951192848"
        },
        customerRating: 4.3,
        starRating: "⭐️⭐️⭐️⭐⭐",
        subtitle: "Cozy Room for Solo Travelers",
    },
    {
        id: "room_002",
        roomType: "Double Bed",
        description: "Designed for couples or friends, this room features a spacious double bed, elegant interiors, and all necessary conveniences, including air conditioning, a TV, and complimentary toiletries. Whether for business or leisure, this room ensures a relaxing and enjoyable stay.",
        features: [
            "Double Bed",
            "Air Conditioning",
            "Wi-Fi",
            "Flat-screen TV",
            "Mini Bar"
        ],
        amenities: [
            "Free Breakfast",
            "Daily Housekeeping",
            "24/7 Room Service",
            "Access to Swimming Pool"
        ],
        pricing: {
            perNight: 7200,
            currency: "INR",
            discounts: {
                weekly: 15,
                monthly: 25
            }
        },
        images: "https://plus.unsplash.com/premium_photo-1670360414628-e26e589fed51?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        occupancy: {
            maxAdults: 2,
            maxChildren: 1
        },
        roomSize: "300 sqft",
        foodAvailability: {
            roomService: true,
            contactNumber: "+91 8951192848"
        },
        customerRating: 4.4,
        starRating: "⭐️⭐️⭐️⭐️",
        subtitle: "Perfect Stay for Two",
    },
    {
        id: "room_003",
        roomType: "Suite",
        description: "Experience luxury with our well-appointed suite, featuring a separate living area, plush bedding, and modern décor. Perfect for guests seeking extra space and comfort, the suite includes premium amenities such as a minibar, smart TV, and a luxurious en-suite bathroom.",
        features: [
            "King Size Bed",
            "Living Room",
            "Air Conditioning",
            "Wi-Fi",
            "Flat-screen TV",
            "Mini Bar",
            "Private Balcony"
        ],
        amenities: [
            "Free Breakfast",
            "Daily Housekeeping",
            "24/7 Room Service",
            "Access to Swimming Pool and Spa",
            "Complimentary Airport Transfers"
        ],
        pricing: {
            perNight: 16000,
            currency: "INR",
            discounts: {
                weekly: 20,
                monthly: 30
            }
        },
        images: "https://plus.unsplash.com/premium_photo-1661964402307-02267d1423f5?q=80&w=1973&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        occupancy: {
            maxAdults: 3,
            maxChildren: 2
        },
        roomSize: "600 sqft",
        foodAvailability: {
            roomService: true,
            contactNumber: "+918951192848"
        },
        customerRating: 5,
        starRating: "⭐️⭐️⭐️⭐",
        subtitle: "Luxury and Space Combined",
    },
    {
        id: "room_004",
        roomType: "Deluxe Double Bed",
        description: " Upgrade your stay with our deluxe double room, offering refined decor, a high-quality double bed, and extra space. Enjoy premium facilities such as a cozy seating area, high-speed Wi-Fi, and a spacious bathroom with luxury toiletries.",
        features: [
            "Double Bed",
            "Air Conditioning",
            "Wi-Fi",
            "Flat-screen TV",
            "Mini Bar",
            "Private Balcony"
        ],
        amenities: [
            "Free Breakfast",
            "Daily Housekeeping",
            "24/7 Room Service",
            "Access to Swimming Pool and Gym"
        ],
        pricing: {
            perNight: 9000,
            currency: "INR",
            discounts: {
                weekly: 15,
                monthly: 25
            }
        },
        images: "https://img.freepik.com/free-photo/3d-rendering-luxury-bedroom-suite-resort-hotel-with-twin-bed-living_105762-2018.jpg?semt=ais_hybrid",
        occupancy: {
            maxAdults: 2,
            maxChildren: 2
        },
        roomSize: "400 sqft",
        foodAvailability: {
            roomService: true,
            contactNumber: "+918951192848"
        },
        customerRating: 4.8,
        starRating: "⭐️⭐️⭐️⭐️⭐",
        subtitle: "Elegant Comfort for a Relaxing Stay",
    },
    {
        id: "room_005",
        roomType: "Family Suite",
        description: " Ideal for families or small groups, this suite offers multiple beds, a spacious living area, and thoughtful amenities to ensure a comfortable stay. With a separate lounge area and entertainment options, it’s designed to make family vacations more enjoyable.",
        features: [
            "King Size Bed",
            "Twin Beds",
            "Living Room",
            "Air Conditioning",
            "Wi-Fi",
            "Flat-screen TV",
            "Mini Bar",
            "Private Balcony"
        ],
        amenities: [
            "Free Breakfast",
            "Daily Housekeeping",
            "24/7 Room Service",
            "Access to Swimming Pool and Kids Play Area"
        ],
        pricing: {
            perNight: 20000,
            currency: "INR",
            discounts: {
                weekly: 20,
                monthly: 30
            }
        },
        images: "https://img.freepik.com/free-photo/interior-modern-comfortable-hotel-room_1232-1822.jpg?ga=GA1.1.1544158794.1739191664&semt=ais_hybrid",
        occupancy: {
            maxAdults: 4,
            maxChildren: 3
        },
        roomSize: "800 sqft",
        foodAvailability: {
            roomService: true,
            contactNumber: "+91 8951192848"
        },
        customerRating: 4.8,
        starRating: "⭐️⭐️⭐️⭐️",
        subtitle: "Spacious Living for the Whole Family",
    },
    {
        id: "room_006",
        roomType: "Presidential Suite",
        description: "The ultimate in luxury, the presidential suite offers an expansive space with an opulent bedroom, private lounge, and high-end amenities. Enjoy VIP services, breathtaking views, and a lavish en-suite bathroom with a Jacuzzi for a truly indulgent experience.",
        features: [
            "King Size Bed",
            "Private Jacuzzi",
            "Living Room",
            "Dining Area",
            "Air Conditioning",
            "Wi-Fi",
            "Flat-screen TV",
            "Mini Bar",
            "Private Terrace"
        ],
        amenities: [
            "Complimentary Breakfast",
            "24/7 Housekeeping",
            "Personal Butler",
            "Access to Private Pool and Spa",
            "Complimentary Airport Transfers"
        ],
        pricing: {
            perNight: 50000,
            currency: "INR",
            discounts: {
                weekly: 25,
                monthly: 35
            }
        },
        images: "https://plus.unsplash.com/premium_photo-1661884238187-1c274b3c3413?q=80&w=1932&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        occupancy: {
            maxAdults: 6,
            maxChildren: 4
        },
        roomSize: "1500 sqft",
        foodAvailability: {
            roomService: true,
            contactNumber: "+91 8951192848"
        },
        customerRating: 5,
        starRating: "⭐️⭐️⭐️⭐⭐",
        subtitle: "Ultimate Luxury and Prestige",
    },
    {
        id: "room_007",
        roomType: "Budget Room",
        description: "A cost-effective option for travelers looking for a comfortable yet affordable stay. This room includes all the essentials such as a cozy bed, free Wi-Fi, and a private bathroom, ensuring a pleasant experience without breaking the bank.",
        features: [
            "Single Bed",
            "Fan",
            "Wi-Fi",
            "Shared Bathroom"
        ],
        amenities: [
            "Daily Housekeeping",
            "24/7 Reception"
        ],
        pricing: {
            perNight: 1500,
            currency: "INR",
            discounts: {
                weekly: 5,
                monthly: 10
            }
        },
        images: "https://images.unsplash.com/photo-1512918728675-ed5a9ecdebfd?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        occupancy: {
            maxAdults: 1,
            maxChildren: 0
        },
        roomSize: "150 sqft",
        foodAvailability: {
            roomService: false,
            contactNumber: "+91 8951192848"
        },
        customerRating: 4.2,
        starRating: "⭐️⭐️⭐️⭐",
        subtitle: "Affordable Stay, Maximum Comfort",
    },
    {
        id: "room_008",
        roomType: "Executive Suite",
        description: " Tailored for business travelers, this suite offers a sophisticated workspace, a plush king-sized bed, and top-notch amenities. Enjoy complimentary breakfast, high-speed internet, and access to executive lounge facilities for a seamless stay.",
        features: [
            "King Size Bed",
            "Work Desk",
            "Air Conditioning",
            "Wi-Fi",
            "Flat-screen TV",
            "Mini Bar"
        ],
        amenities: [
            "Free Breakfast",
            "Daily Housekeeping",
            "24/7 Room Service",
            "Access to Business Center"
        ],
        pricing: {
            perNight: 12000,
            currency: "INR",
            discounts: {
                weekly: 18,
                monthly: 28
            }
        },
        images: "https://plus.unsplash.com/premium_photo-1661962459469-27479898b31e?q=80&w=2048&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        occupancy: {
            maxAdults: 2,
            maxChildren: 1
        },
        roomSize: "450 sqft",
        foodAvailability: {
            roomService: true,
            contactNumber: "+91 8951192848"
        },
        customerRating: 4.5,
        starRating: "⭐️⭐️⭐️⭐️",
        subtitle: "Premium Stay for Business & Leisure",
    },
    {
        id: "room_009",
        roomType: "Standard Room",
        description: "A well-furnished and stylishly designed room with all the essentials for a hassle-free stay. Featuring a comfortable bed, a private bathroom, and modern amenities, this room is perfect for both business and leisure travelers.",
        features: [
            "Queen Size Bed",
            "Air Conditioning",
            "Wi-Fi",
            "Flat-screen TV"
        ],
        amenities: [
            "Free Breakfast",
            "Daily Housekeeping",
            "24/7 Room Service"
        ],
        pricing: {
            perNight: 5000,
            currency: "INR",
            discounts: {
                weekly: 12,
                monthly: 22
            }
        },
        images: "https://plus.unsplash.com/premium_photo-1675615667752-2ccda7042e7e?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        occupancy: {
            maxAdults: 2,
            maxChildren: 0
        },
        roomSize: "250 sqft",
        foodAvailability: {
            roomService: true,
            contactNumber: "+91 8951192848"
        },
        customerRating: 4.7,
        starRating: "⭐️⭐️⭐️⭐️",
        subtitle: "Simple, Stylish, and Comfortable",
    },
    {
        id: "room_010",
        roomType: "Penthouse",
        description: "Indulge in unparalleled luxury with our penthouse suite, featuring panoramic views, a private terrace, and exquisite interiors. This elite accommodation includes a spacious living area, top-tier amenities, and personalized services to create an unforgettable experience.",
        features: [
            "King Size Bed",
            "Private Rooftop",
            "Living Room",
            "Dining Area",
            "Air Conditioning",
            "Wi-Fi",
            "Flat-screen TV",
            "Mini Bar"
        ],
        amenities: [
            "Complimentary Breakfast",
            "24/7 Concierge Service",
            "Access to Private Pool and Spa",
            "Complimentary Airport Transfers"
        ],
        pricing: {
            perNight: 70000,
            currency: "INR",
            discounts: {
                weekly: 30,
                monthly: 40
            }
        },
        images: "https://images.unsplash.com/photo-1620086385485-d0bd6daa815c?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        occupancy: {
            maxAdults: 5,
            maxChildren: 3
        },
        roomSize: "2000 sqft",
        foodAvailability: {
            roomService: true,
            contactNumber: "+91 8951192848"
        },
        customerRating: 4.9,
        starRating: "⭐️⭐️⭐️⭐️⭐",
        subtitle: "Exclusive Luxury with a Stunning View",
    }
]
